import { Chapter } from './chapter';
import { CoordinatorService } from './coordinator.service';

export class ScriptChapter {
    #coords: CoordinatorService;
    #chapter: Chapter;

    constructor(coords: CoordinatorService, chapter: Chapter) {
        this.#coords = coords;
        this.#chapter = chapter;
    }

    get title() {
        return this.#chapter.title;
    }
}
